<template>
  <div class="page">
    <h1 class="page__heading">Urbanismus a územní plánování</h1>
    <div class="page__info">
      <span>
        <a href="/" class="page__info-type">Domů</a> >
        <em>
          <span>Urbanismus a územní plánování</span>
        </em>
      </span>
    </div>
    <h3>Můj přístup k urbanismu a územnímu plánování</h3>
    <p>Pro mě je urbanismus a územní plánování spojením profesionální sféry a osobní vášně. Cílem mé práce je vytvářet harmonický vztah mezi přírodou a architekturou skrze řešení, které respektuje historické a kulturní hodnoty daného území, ale zároveň je otevřené moderním trendům a technologiím.</p>
<p>Každý urbanistický a plánovací projekt vnímám jako jedinečnou výzvu, kde se snažím najít rovnováhu mezi různými aspekty - ekonomickými, sociálními, ekologickými a estetickými. Mým cílem je najít řešení, která nejen splňují požadavky moderní doby, ale také obohacují a rozvíjejí přírodní a kulturní hodnoty daného území pro budoucí generace.</p>
    <Portfolio :portfolioLinks="portfolioLinks"></Portfolio>
    <Message id="napiste-mi" :messageDesc="'Měli byste zájem o vypracování územního plánu nebo jeho změny? Potřebujete zpracovat územní nebo urbanistickou studii? Napište mi!'"></Message>
  </div>
</template>

<script>
import axios from "axios";
import Portfolio from "@/components/Portfolio";
import Message from "@/components/Message";

import moment from "moment";
moment.locale("cs");

export default {
  name: "page",
  components: {
    Message,
    Portfolio
  },
  data() {
    return {
      portfolioLinks: [],
      loading: true,
    };
  },
  created() {
    axios
      .get(
        'items/atelier_projekty?fields=type,date,heading,tags,slug,intro,intro_img.title,intro_img.id&filter={"_or":[{"tags":{"_contains":"urbanismus"}},{"tags":{"_contains":"územní%20plánování"}}]}'
      )
      .then((res) => {
        if (res.status == 200) {
          this.portfolioLinks = res.data.data;
          this.loading = false;
        } else {
          //some error handling
        }
      });
  },
  filters: {
    moment: function (date) {
      return moment(date).format("MMMM YYYY");
    },
  },
};
</script>
<style>
.page {
  padding: 0 48px;
}

.page > div {
  padding: 24px 0;
}

.page h1 {
  font-size: 4rem;
  text-align: center;
  letter-spacing: 0;
  margin: 64px 0 0 0;
  text-transform: capitalize;
}

.page h2 {
  font-size: 3rem;
}

.page__info {
  text-align: center;
}

.page__info > span {
  padding: 0 12px;
}

.page__info-type {
  text-transform: capitalize;
}

/* Loader */
.page__loader {
  display: flex;
  justify-page: center;
  align-items: center;
  width: 100vw;
  height: 100vh;
  margin: auto;
}

@media only screen and (min-width: 1200px) {
  .page {
    padding-left: 10vw;
    padding-right: 10vw;
  }
}

@media only screen and (max-width: 400px) {
  .page {
    padding: 0 24px;
  }
}
</style>
